import { Profile } from '../../components/font-end/Profile/Profile';
import { Menubar } from '../../components/font-end/MasterLayout/Menubar';
import { AnouncementList } from '../../components/font-end/Anouncement/AnouncementList';
import { useUser } from '../../context/UserContext';

export const Anouncement = (props: any) => {
  const { isLoading } = useUser();

  if (isLoading) {
    return (
      <div className="loading-pages text-center" style={{ backgroundColor: '#f0f0f0' }}>
        <div className="layout-loading">
          <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Profile />
      <AnouncementList />
      <Menubar />
    </>
  );
};
